import { Consultation } from '@abiglobalhealth/go-types'

import { useConsultation } from '@/hooks/useConsultation'

type UsePrescriptionProps = {
  prescription: Consultation['prescription']
}

export const usePrescription = (): UsePrescriptionProps => {
  const { consultation } = useConsultation()

  return {
    prescription: consultation?.prescription
  }
}
